import React, { useEffect, useState } from 'react';
import { CloseOutlined, DownloadOutlined, ShareAltOutlined } from '@ant-design/icons';
import './PwaInstallPrompt.css';

const isStandalone = () =>
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

const isIos = () =>
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const PwaInstallPrompt = () => {
    const [installEvent, setInstallEvent] = useState(null);
    const [showIosHint, setShowIosHint] = useState(false);
    const [dismissed, setDismissed] = useState(
        () => sessionStorage.getItem('bansel-pwa-prompt-dismissed') === '1'
    );

    useEffect(() => {
        if (isStandalone()) return undefined;

        const handleInstallPrompt = (event) => {
            event.preventDefault();
            setInstallEvent(event);
        };
        const handleInstalled = () => {
            setInstallEvent(null);
            setShowIosHint(false);
        };

        window.addEventListener('beforeinstallprompt', handleInstallPrompt);
        window.addEventListener('appinstalled', handleInstalled);
        if (isIos()) setShowIosHint(true);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleInstallPrompt);
            window.removeEventListener('appinstalled', handleInstalled);
        };
    }, []);

    const dismiss = () => {
        sessionStorage.setItem('bansel-pwa-prompt-dismissed', '1');
        setDismissed(true);
    };

    const install = async () => {
        if (!installEvent) return;
        await installEvent.prompt();
        const choice = await installEvent.userChoice;
        if (choice.outcome === 'accepted') {
            setInstallEvent(null);
        }
    };

    if (dismissed || (!installEvent && !showIosHint)) return null;

    return (
        <aside className="pwa-install" aria-label="Установка приложения">
            <div className="pwa-install__icon">
                {showIosHint && !installEvent ? <ShareAltOutlined /> : <DownloadOutlined />}
            </div>
            <div className="pwa-install__text">
                <strong>Установить BananaSeller</strong>
                <span>
                    {showIosHint && !installEvent
                        ? 'Нажмите «Поделиться», затем «На экран Домой»'
                        : 'Откройте приложение с рабочего стола'}
                </span>
            </div>
            {installEvent && (
                <button type="button" className="pwa-install__action" onClick={install}>
                    Установить
                </button>
            )}
            <button
                type="button"
                className="pwa-install__close"
                onClick={dismiss}
                aria-label="Закрыть"
            >
                <CloseOutlined />
            </button>
        </aside>
    );
};

export default PwaInstallPrompt;
